"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
var _icons = require("../icons");
var _icon_button = _interopRequireDefault(require("./icon_button"));
var _typography = require("../typography");
var _animations = require("../animations");
var _colors = require("../../birch/colors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../animations'. 'src/azalea/animations/index.js' implicitly has an 'any' type.

var birchTheme = {
  icon: {
    backgroundColor: 'transparent',
    fillColor: _colors.FullPalette.EVERGREEN_700,
    hoverBgColor: 'transparent'
  }
};
var AudioPlayer = function AudioPlayer(props) {
  var _useState = (0, _react.useState)('stopped'),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    player = _useState4[0],
    setPlayer = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isHovered = _useState6[0],
    setIsHovered = _useState6[1];
  (0, _react.useEffect)(function () {
    if (player !== undefined) console.log("\uD83C\uDFB5 Audio Player: ".concat(status));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);
  (0, _react.useEffect)(function () {
    if (player !== undefined) {
      // @ts-expect-error - TS2339 - Property 'addEventListener' does not exist on type 'never'.
      player.addEventListener('ended', stopAudio);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);
  var playAudio = function playAudio() {
    if (player === undefined) return null;

    // @ts-expect-error - TS2339 - Property 'play' does not exist on type 'never'.
    var playerPromise = player.play();

    // Some browsers don't return a Promise from play()
    if (playerPromise !== undefined) {
      playerPromise.then(function () {
        return setStatus('playing');
      })
      // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
      ["catch"](function (error) {
        return props.playErrorCallback(error);
      });
    } else {
      setStatus('playing');
    }
  };
  var stopAudio = function stopAudio() {
    if (player === undefined) return null;

    // @ts-expect-error - TS2339 - Property 'pause' does not exist on type 'never'.
    player.pause();
    // @ts-expect-error - TS2339 - Property 'currentTime' does not exist on type 'never'.
    player.currentTime = 0;
    setStatus('stopped');
  };
  var togglePlaying = function togglePlaying(event) {
    event && event.preventDefault();
    isPlaying() ? stopAudio() : playAudio();
  };
  var isPlaying = function isPlaying() {
    return status === 'playing';
  };
  var extraControls = function extraControls() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, isPlaying() ? /*#__PURE__*/React.createElement(Playing, null, "Playing your recording...") : /*#__PURE__*/React.createElement(FileName, {
      href: props.sourceUrl,
      target: "_blank",
      onClick: togglePlaying,
      "data-provides": "file-name",
      $isHovered: isHovered
    }, props.fileName), !isPlaying() && /*#__PURE__*/React.createElement(_icon_button["default"], {
      label: 'Delete',
      size: 'medium'
      // @ts-expect-error - TS2322
      ,
      Icon: _icons.TrashCanIcon,
      onClick: props.deleteCallback
    }));
  };
  var Icon = isPlaying() ? _icons.StopIcon : _icons.PlayIcon;
  var iconColor = birchTheme.icon.fillColor;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    }
  }, /*#__PURE__*/React.createElement(PlaybackButton, {
    onClick: togglePlaying
    // @ts-expect-error - TS2769 - No overload matches this call.
    ,
    compact: props.compact,
    $isPlaying: isPlaying(),
    $isHovered: isHovered,
    "data-provides": "playback-control",
    "data-provides-of": status
  }, /*#__PURE__*/React.createElement(_typography.Label, null, isPlaying() ? 'Stop' : 'Play'), /*#__PURE__*/React.createElement(Icon, {
    color: iconColor
  })), !props.compact && props.sourceUrl && extraControls()), /*#__PURE__*/React.createElement("audio", {
    controls: false,
    src: props.sourceUrl
    // @ts-expect-error - TS2345 - Argument of type 'HTMLAudioElement | null' is not assignable to parameter of type 'SetStateAction<undefined>'.
    ,
    ref: function ref(_ref) {
      return setPlayer(_ref);
    }
    // @ts-expect-error - TS2322 - Type '{ controls: false; src: string; ref: (ref: HTMLAudioElement | null) => void; type: string; "data-provides": string; }' is not assignable to type 'DetailedHTMLProps<AudioHTMLAttributes<HTMLAudioElement>, HTMLAudioElement>'.
    ,
    type: "audio/mp3",
    "data-provides": "audio-element"
  }));
};
AudioPlayer.displayName = 'AudioPlayer';
AudioPlayer.defaultProps = {
  compact: true,
  // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
  playErrorCallback: function playErrorCallback(error) {
    return console.error(error);
  },
  deleteCallback: function deleteCallback() {},
  fileName: 'Anonymous.mp3'
};
var PlaybackButton = _styledComponents["default"].div.withConfig({
  displayName: "audio_player__PlaybackButton"
})(["position:relative;background:", ";border:solid 1px ", ";border-radius:50%;cursor:pointer;display:inline-block;vertical-align:middle;box-shadow:0 0 0 rgba(36,164,127,0.4);will-change:box-shadow;width:32px;height:32px;", "{display:none;}svg{display:block;position:relative;path{fill:", ";}top:50%;left:50%;transform:translate(-49%,-51%);", "}", " ", " ", ""], birchTheme.icon.backgroundColor, _colors.FullPalette.EVERGREEN_700, _typography.Label, birchTheme.icon.fillColor, function (props) {
  return (
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"data-provides-of"' can't be used to index type 'Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; } & ThemeProps<...>'.
    props['data-provides-of'] === 'playing' && "transform: translate(-49%, -50%);"
  );
}, function (props) {
  return (
    // @ts-expect-error - TS2339 - Property 'compact' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; }, DefaultTheme>'.
    props.compact && "width: 24px; height: 24px; svg { width: 15px; height: 15px; transform: translate(-51%, -52%);}"
  );
}, function (props) {
  return props.$isHovered && "background: ".concat(birchTheme.icon.hoverBgColor, ";");
}, function (props) {
  return props.$isPlaying && _animations.PulseAnimation;
});
var FileName = _styledComponents["default"].a.withConfig({
  displayName: "audio_player__FileName"
})(["padding:7px 15px;display:inline-block;vertical-align:middle;text-decoration:none;color:", ";&:visited{color:", ";}", " ", ""], _constants.colors.darkGrey, _constants.colors.darkGrey, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.isHovered && "text-decoration: underline;";
});
var Playing = _styledComponents["default"].span.withConfig({
  displayName: "audio_player__Playing"
})(["margin:0 15px;display:inline-block;vertical-align:middle;font-style:italic;"]);
Playing.displayName = 'Playing';
var _default = exports["default"] = AudioPlayer;